import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AfDataType } from "utils/TableColumnData";
import Select from "react-select";
import handleWheel from "utils/handleOnWheel";
import { ErrorMessage } from "components/ErrorMessage";
import { UseMutateFunction, useMutation } from "@tanstack/react-query";
import { GetCommanWay } from "API/commonApi";
import { AxiosResponse } from "axios";
import Swal from "sweetalert2";

export type AfTableProps = Partial<{
  selectedAwb: any;
  isExtraOpen: any;
  tableData: any[];
  setIsExtraOpen: any;
  setTableData: any;
  product: string;
}>;

const ExtraAmtCustomerData: React.FC<AfTableProps> = ({
  tableData = [],
  selectedAwb = 0,
  isExtraOpen,
  setIsExtraOpen,
  setTableData,
  product,
}) => {
  //const [tableData_, settableData_] = useState<any[]>(tableData);

  const [amtOrGrand, setAmtOrGrand] = useState("");

  useEffect(() => {
    setTableData(tableData);
  }, [tableData]);

  
  const onInputchange2 = (val, key) => {
    let _tableData_ = JSON.parse(JSON.stringify(tableData));
    _tableData_[selectedAwb][key] = val;
    setTableData(_tableData_);
  };
  const onInputchange = (e, key) => {
    //return;
    let _tableData_ = JSON.parse(JSON.stringify(tableData));
    let val = e.target.value === "" ? e.target.value : Number(e.target.value);
    if (isNaN(val)) {
      return;
    }
    _tableData_[selectedAwb][key] = val;
    setTableData(_tableData_);
  };

  const onCheckboxCheck = (e, key) => {
    //return;
    let _tableData_ = JSON.parse(JSON.stringify(tableData));
    _tableData_[selectedAwb][key] = e.target.checked ? "1" : "";
    setTableData(_tableData_);
  };

  // Helper for pkgData JSON field
  const onPkgDataChange = (e, key) => {
    let _tableData_ = JSON.parse(JSON.stringify(tableData));
    let pkgData = _tableData_[selectedAwb]["pkgData"];
    if (typeof pkgData === "string") {
      try {
        pkgData = JSON.parse(pkgData || "{}");
      } catch {
        pkgData = {};
      }
    }
    if (!pkgData) pkgData = {};
    const val = e.target.checked ? "1" : "";
    pkgData[key] = val;
    _tableData_[selectedAwb]["pkgData"] = pkgData;
    setTableData(_tableData_);
  };

  const getPkgDataValue = (key) => {
    let pkgData = tableData[selectedAwb]?.["pkgData"];
    if (typeof pkgData === "string") {
      try {
        pkgData = JSON.parse(pkgData || "{}");
      } catch {
        pkgData = {};
      }
    }
    return pkgData?.[key];
  };

  const GetCheckBox = (key) => {
    return (
      <input
        type="checkbox"
        checked={tableData[selectedAwb][key] != "0" && tableData[selectedAwb][key]}
        onChange={(e) => {
          onCheckboxCheck(e, key);
        }}
        className={`w-8 h-8 focus:border-black-900 p-1 rounded-md`}
      />
    );
  };
  return (
    <div className="absolute top-0 left-0 w-full h-full bg-white bg-opacity-60 z-10 flex justify-center items-center">
      <div className="bg-white border border-blue-300 p-3 rounded-md shadow-lg">
      
      <div className="border-b border-black-900 mb-4 pb-4">
          <table>
            <thead>
              <tr>
                <th>L</th>
                <th>B</th>
                <th>H</th>
                <th>10:30</th>
                <th>Holiday</th>
                <th className="pb-1 border-x px-2 text-center">particulars</th>
                <th className="pb-1 border-x px-2 text-center">commercial Value</th>
                <th className="pb-1 border-x px-2 text-center">FOD</th>
                <th className="pb-1 border-x px-2 text-center">COD</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="pb-1 border-x px-2 text-center">
                  <input
                    type="text"
                    value={tableData[selectedAwb]["l"]}
                    onChange={(e) => {
                      onInputchange(e, "l");
                    }}
                    className={`w-14 focus:border-black-900 p-1 rounded-md`}
                  />
                </td>
                <td className="pb-1 border-x px-2 text-center">
                  <input
                    type="text"
                    value={tableData[selectedAwb]["b"]}
                    onChange={(e) => {
                      onInputchange(e, "b");
                    }}
                    className={`w-14 focus:border-black-900 p-1 rounded-md`}
                  />
                </td>
                <td className="pb-1 border-x px-2 text-center">
                  <input
                    type="text"
                    value={tableData[selectedAwb]["h"]}
                    onChange={(e) => {
                      onInputchange(e, "h");
                    }}
                    className={`w-14 focus:border-black-900 p-1 rounded-md`}
                  />
                </td>
                <td className="pb-1 border-x px-2 text-center">
                  <Select
                    className={`flex-1 bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg block w-full`}
                    options={[
                      { value: true, label: "Yes" },
                      { value: false, label: "No" },
                    ]}
                    onChange={(e) => {
                      onInputchange2(e.value, "is10_30");
                    }}
                    name="is10_30"
                    value={tableData[selectedAwb]["is10_30"] ? { value: true, label: "Yes" } : { value: false, label: "No" }}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                  />
                </td>
                <td className="pb-1 border-x px-2 text-center">
                  <Select
                    className={`flex-1 bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg block w-full`}
                    options={[
                      { value: true, label: "Yes" },
                      { value: false, label: "No" },
                    ]}
                    onChange={(e) => {
                      onInputchange2(e.value, "holiday");
                    }}
                    name="holiday"
                    value={tableData[selectedAwb]["holiday"] ? { value: true, label: "Yes" } : { value: false, label: "No" }}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                  />
                </td>

                <td className="pb-1 border-x px-2 text-center">
                  <input
                    type="text"
                    value={tableData[selectedAwb]["particulars"]}
                    onChange={(e) => {
                      onInputchange2(e.target.value, "particulars");
                    }}
                    className={`w-40 focus:border-black-900 p-1 rounded-md`}
                  />
                </td>
                <td className="pb-1 border-x px-2 text-center">
                  <input
                    type="text"
                    value={tableData[selectedAwb]["commercialValue"]}
                    onChange={(e) => {
                      onInputchange2(e.target.value, "commercialValue");
                    }}
                    className={`w-32 focus:border-black-900 p-1 rounded-md`}
                  />
                </td>
                <td className="pb-1 border-x px-2 text-center">{GetCheckBox("isFod")}</td>
                <td className="pb-1 border-x px-2 text-center">{GetCheckBox("isCod")}</td>
              </tr>
            </tbody>
          </table>
          <label></label>
        </div>
        <hr />

        <div className="border-b border-black-900 mb-4 pb-4">
          <table>
            <thead>
              <tr>
                <th className="pb-1 border-x px-2 text-center">
                  To-Pay
                  <br />
                  Charge
                </th>
                <th className="pb-1 border-x px-2 text-center">
                  Pickup
                  <br />
                  Charge
                </th>
                <th className="pb-1 border-x px-2 text-center">
                  Delivery
                  <br />
                  Charge
                </th>
                <th className="pb-1 border-x px-2 text-center">
                  Oda
                  <br />
                  Charge
                </th>
                <th className="pb-1 border-x px-2 text-center">
                  Demurrage
                  <br />
                  Charge
                </th>
                <th className="pb-1 border-x px-2 text-center">
                  Other
                  <br />
                  Charge
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="pb-1 border-x px-2 text-center">{GetCheckBox("toPayRate")}</td>

                <td className="pb-1 border-x px-2 text-center">
                  <input
                    type="text"
                    value={tableData[selectedAwb]["pickupRate"]}
                    onChange={(e) => {
                      onInputchange(e, "pickupRate");
                    }}
                    className={`w-20 focus:border-black-900 p-1 rounded-md ${amtOrGrand == "grand" ? "bg-gray-400" : ""}`}
                  />
                </td>
                <td className="pb-1 border-x px-2 text-center">
                  <input
                    type="text"
                    value={tableData[selectedAwb]["deliveryRate"]}
                    onChange={(e) => {
                      onInputchange(e, "deliveryRate");
                    }}
                    className={`w-20 focus:border-black-900 p-1 rounded-md ${amtOrGrand == "grand" ? "bg-gray-400" : ""}`}
                  />
                </td>
                <td className="pb-1 border-x px-2 text-center">
                  <input
                    type="text"
                    value={tableData[selectedAwb]["odaRate"]}
                    onChange={(e) => {
                      onInputchange(e, "odaRate");
                    }}
                    className={`w-20 focus:border-black-900 p-1 rounded-md ${amtOrGrand == "grand" ? "bg-gray-400" : ""}`}
                  />
                </td>
                <td className="pb-1 border-x px-2 text-center">
                  <input
                    type="text"
                    value={tableData[selectedAwb]["demurrageRate"]}
                    onChange={(e) => {
                      onInputchange(e, "demurrageRate");
                    }}
                    className={`w-20 focus:border-black-900 p-1 rounded-md ${amtOrGrand == "grand" ? "bg-gray-400" : ""}`}
                  />
                </td>
                <td className="pb-1 border-x px-2 text-center">
                  <input
                    type="text"
                    value={tableData[selectedAwb]["otherRate"]}
                    onChange={(e) => {
                      onInputchange(e, "otherRate");
                    }}
                    className={`w-20 focus:border-black-900 p-1 rounded-md ${amtOrGrand == "grand" ? "bg-gray-400" : ""}`}
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <label></label>
        </div>
        <hr />

        <div className="border-b border-black-900 mb-4 pb-4">
          <table>
            <thead>
              <tr>
                <th>FOV Rate</th>
                <th>Insurance Rate</th>
                <th>insurance No</th>
                <th>insurance Amount</th>
                <th>insurance Company</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="pb-1 border-x px-2 text-center">{GetCheckBox("fovRate")}</td>
                <td className="pb-1 border-x px-2 text-center">{GetCheckBox("insuranceRate")}</td>
                <td className="pb-1 border-x px-2 text-center">
                  <input
                    type="text"
                    value={tableData[selectedAwb]["insuranceNo"]}
                    onChange={(e) => {
                      onInputchange2(e.target.value, "insuranceNo");
                    }}
                    className={`w-32 focus:border-black-900 p-1 rounded-md ${amtOrGrand == "grand" ? "bg-gray-400" : ""}`}
                  />
                </td>
                <td className="pb-1 border-x px-2 text-center">
                  <input
                    type="text"
                    value={tableData[selectedAwb]["insuranceAmount"]}
                    onChange={(e) => {
                      onInputchange(e, "insuranceAmount");
                    }}
                    className={`w-32 focus:border-black-900 p-1 rounded-md ${amtOrGrand == "grand" ? "bg-gray-400" : ""}`}
                  />
                </td>
                <td className="pb-1 border-x px-2 text-center">
                  <input
                    type="text"
                    value={tableData[selectedAwb]["insuranceCompany"]}
                    onChange={(e) => {
                      onInputchange2(e.target.value, "insuranceCompany");
                    }}
                    className={`w-40 focus:border-black-900 p-1 rounded-md ${amtOrGrand == "grand" ? "bg-gray-400" : ""}`}
                  />
                </td>
                
              </tr>
            </tbody>
          </table>
          <label></label>
        </div>
        <hr />
        
        <table>
          <tr className="border-b border-black-900">
            <td className="pb-1 border-x px-2 text-center w-28">Dry Ice</td>
            <td className="pb-1 border-x px-2 text-center w-28">DG</td>
            <td className="pb-1 border-x px-2 text-center w-28">PKG</td>

            <td className="pb-1 border-x px-2 text-center w-28">1 LT</td>
            <td className="pb-1 border-x px-2 text-center w-28">4 LT</td>
            <td className="pb-1 border-x px-2 text-center w-28">10 LT</td>

            <td className="pb-1 border-x px-2 text-center w-28">Cube-6</td>
            <td className="pb-1 border-x px-2 text-center w-28">Cube-8</td>
            <td className="pb-1 border-x px-2 text-center w-28">Cube-13</td>

          </tr>

          {tableData && (
            <tr>
              <td className="pt-2 border-x px-2 text-center">
                <input
                  type="text"
                  value={tableData[selectedAwb]["diceWeight"]}
                  onChange={(e) => {
                    onInputchange2(e.target.value, "diceWeight");
                  }}
                  className={`w-20 focus:border-black-900 p-1 rounded-md ${amtOrGrand == "grand" ? "bg-gray-400" : ""}`}
                />

                {/*<input
                  type="checkbox"
                  checked={tableData[selectedAwb]["diceWeight"] != "0" && tableData[selectedAwb]["diceWeight"]}
                  onChange={(e) => {
                    onCheckboxCheck(e, "diceWeight");
                  }}
                  className={`w-8 h-8 focus:border-black-900 p-1 rounded-md`}
                />*/}
              </td>

              <td className="pt-2 border-x px-2 text-center">
                <input
                  type="checkbox"
                  checked={tableData[selectedAwb]["dgRate"] != "0" && tableData[selectedAwb]["dgRate"]}
                  onChange={(e) => {
                    onCheckboxCheck(e, "dgRate");
                  }}
                  className={`w-8 h-8 focus:border-black-900 p-1 rounded-md`}
                />
              </td>

              <td className="pt-2 border-x px-2 text-center">
                <input
                  type="checkbox"
                  checked={tableData[selectedAwb]["extraPkgRate"] != "0" && tableData[selectedAwb]["extraPkgRate"]}
                  onChange={(e) => {
                    onCheckboxCheck(e, "extraPkgRate");
                  }}
                  className={`w-8 h-8 focus:border-black-900 p-1 rounded-md`}
                />
              </td>

              <td className="pt-2 border-x px-2 text-center">
                <input
                  type="checkbox"
                  checked={tableData[selectedAwb]["pkg1Rate"] != "0" && tableData[selectedAwb]["pkg1Rate"]}
                  onChange={(e) => {
                    onCheckboxCheck(e, "pkg1Rate");
                  }}
                  className={`w-8 h-8 focus:border-black-900 p-1 rounded-md`}
                />
              </td>

              <td className="pt-2 border-x px-2 text-center">
                <input
                  type="checkbox"
                  checked={tableData[selectedAwb]["pkg2Rate"] != "0" && tableData[selectedAwb]["pkg2Rate"]}
                  onChange={(e) => {
                    onCheckboxCheck(e, "pkg2Rate");
                  }}
                  className={`w-8 h-8 focus:border-black-900 p-1 rounded-md`}
                />
              </td>

              <td className="pt-2 border-x px-2 text-center">
                <input
                  type="checkbox"
                  checked={tableData[selectedAwb]["pkg3Rate"] != "0" && tableData[selectedAwb]["pkg3Rate"]}
                  onChange={(e) => {
                    onCheckboxCheck(e, "pkg3Rate");
                  }}
                  className={`w-8 h-8 focus:border-black-900 p-1 rounded-md`}
                />
              </td>

              <td className="pt-2 border-x px-2 text-center">
                <input
                  type="checkbox"
                  checked={getPkgDataValue("cube6") != "0" && getPkgDataValue("cube6")}
                  onChange={(e) => {
                    onPkgDataChange(e, "cube6");
                  }}
                  className={`w-8 h-8 focus:border-black-900 p-1 rounded-md`}
                />
              </td>

              <td className="pt-2 border-x px-2 text-center">
                <input
                  type="checkbox"
                  checked={getPkgDataValue("cube8") != "0" && getPkgDataValue("cube8")}
                  onChange={(e) => {
                    onPkgDataChange(e, "cube8");
                  }}
                  className={`w-8 h-8 focus:border-black-900 p-1 rounded-md`}
                />
              </td>

              <td className="pt-2 border-x px-2 text-center">
                <input
                  type="checkbox"
                  checked={getPkgDataValue("cube13") != "0" && getPkgDataValue("cube13")}
                  onChange={(e) => {
                    onPkgDataChange(e, "cube13");
                  }}
                  className={`w-8 h-8 focus:border-black-900 p-1 rounded-md`}
                />
              </td>
            </tr>
          )}
        </table>
        <div className="text-right">
          <button
            className="rounded-md py-2 px-3 mt-3 text-sm font-medium text-white bg-blue-800 border border-gray-200 hover:bg-gray-100 hover:text-blue-700 ml-2"
            type="button"
            onClick={() => {
              setIsExtraOpen(false);
              console.log(tableData);
            }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export { ExtraAmtCustomerData };
